(function () {
  const section = document.currentScript?.parentElement;
  if (window.pawkivoCollapsibleContent) {
    window.pawkivoCollapsibleContent.init(section);
    return;
  }

  const boundToggles = new WeakSet();
  const animations = new WeakMap();

  const cancelAnimation = (element) => {
    const animation = animations.get(element);
    if (!animation) return;
    cancelAnimationFrame(animation.frame);
    clearTimeout(animation.timer);
    animations.delete(element);
  };

  const slideUp = (element, duration = 300) => {
    if (!element) return;
    cancelAnimation(element);
    element.style.height = `${element.scrollHeight}px`;
    element.style.overflow = "hidden";
    element.style.transition = `height ${duration}ms ease`;

    const frame = requestAnimationFrame(() => {
      element.style.height = "0";
    });

    const timer = setTimeout(() => {
      element.style.display = "none";
      element.style.removeProperty("height");
      element.style.removeProperty("overflow");
      element.style.removeProperty("transition");
      animations.delete(element);
    }, duration);
    animations.set(element, { frame, timer });
  };

  const slideDown = (element, duration = 300) => {
    if (!element) return;
    cancelAnimation(element);

    element.style.removeProperty("display");
    let display = window.getComputedStyle(element).display;

    if (display === "none") display = "block";
    element.style.display = display;

    const height = element.scrollHeight;

    element.style.height = "0";
    element.style.overflow = "hidden";
    element.style.transition = `height ${duration}ms ease`;

    const frame = requestAnimationFrame(() => {
      element.style.height = `${height}px`;
    });

    const timer = setTimeout(() => {
      element.style.removeProperty("height");
      element.style.removeProperty("overflow");
      element.style.removeProperty("transition");
      animations.delete(element);
    }, duration);
    animations.set(element, { frame, timer });
  };

  const setExpanded = (item, expanded) => {
    item.classList.toggle("active", expanded);
    item.querySelector(".collapsible-content__toggle")?.setAttribute("aria-expanded", String(expanded));
    const answer = item.querySelector(".collapsible-content__answer");
    if (expanded) slideDown(answer);
    else slideUp(answer);
  };

  const initCollapsibleContent = (section) => {
    if (!section || !section?.classList.contains("collapsible-content-section"))
      return;
    section.querySelectorAll(".collapsible-content__toggle").forEach((toggle) => {
      if (boundToggles.has(toggle)) return;
      boundToggles.add(toggle);
      const item = toggle.closest(".collapsible-content__item");
      toggle.setAttribute("aria-expanded", String(item.classList.contains("active")));
      toggle.addEventListener("click", () => {
        const expanded = !item.classList.contains("active");
        section.querySelectorAll(".collapsible-content__item.active").forEach((activeItem) => {
          if (activeItem !== item) setExpanded(activeItem, false);
        });
        setExpanded(item, expanded);
      });
    });
  };

  window.pawkivoCollapsibleContent = { init: initCollapsibleContent };
  document.addEventListener("shopify:section:load", function (event) {
    initCollapsibleContent(event.target);
  });
  document.addEventListener("shopify:section:unload", function (event) {
    event.target.querySelectorAll(".collapsible-content__answer").forEach(cancelAnimation);
  });
  initCollapsibleContent(section);
})();
